/** Ressources de traduction statiques ; les clés restent vérifiées par TypeScript. */
import textes from './traductions/communication-publics.json' with { type: 'json' };
export const TEXTES_COMMUNICATION_PUBLICS = textes;
//# sourceMappingURL=textes-communication-publics.js.map